<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
        <v-layout wrap>
            <v-flex xs12>
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="donor && donor.personID"
                            >
                                <div
                                    class="display-1 pt-2 font-weight-bold mb-0 ml-0"
                                >
                                    {{ donor.nameH }}
                                </div>
                                <div class="ml-0 mt-4">
                                    <div class="pl-3">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Donor ID:
                                            </div>
                                            <div>
                                                {{ donor.personID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Father:
                                            </div>
                                            <div>
                                                {{ donor.father }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Father In Law:
                                            </div>
                                            <div>
                                                {{ donor.fatherInLaw }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Address:
                                            </div>
                                            <div>
                                                {{ donor.address1 }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Email Address:
                                            </div>
                                            <div>
                                                {{ donor.emailAddress }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-for="phone in phonesNumbers"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                {{
                                                    getPhoneType(
                                                        phone.phoneType
                                                    )
                                                }}:
                                            </div>
                                            <div>
                                                {{ phone.phoneNum }}
                                            </div>
                                        </v-layout>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>
                </v-card>

                <v-card
                    class="pa-3 mt-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#donations">
                            Donations ({{ transactions.length }})
                            <v-icon>mdi-currency-usd</v-icon>
                        </v-tab>

                        <v-tab-item value="donations">
                            <v-card-text
                                class="text-xs-center title mt-3"
                                v-if="!transactions.length"
                                >No Donations</v-card-text
                            >

                            <v-expansion-panel
                                v-if="transactions.length"
                                class="expansion-panel-margin mt-3"
                            >
                                <v-expansion-panel-content
                                    v-for="transaction in transactions"
                                >
                                    <template v-slot:header>
                                        <v-flex xs3 class="pl-0">
                                            <v-layout
                                                row
                                                align-start
                                                class="pa-0 mx-0"
                                            >
                                                <v-layout
                                                    column
                                                    class="py-0 ma-0"
                                                >
                                                    <v-flex xs3>
                                                        <v-layout row>
                                                            <v-icon
                                                                class="mr-3"
                                                                dark
                                                                :color="
                                                                    getStatusIconColor(
                                                                        transaction
                                                                    )
                                                                "
                                                                >{{
                                                                    getStatusIcon(
                                                                        transaction
                                                                    )
                                                                }}</v-icon
                                                            >
                                                            <div>
                                                                <div
                                                                    class="subheading mb-1"
                                                                >
                                                                    {{
                                                                        transaction.dateTime
                                                                            | time
                                                                    }}
                                                                </div>
                                                                <div
                                                                    class="text--disabled subheading"
                                                                >
                                                                    {{
                                                                        transaction.pmtType
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-layout>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                        <v-flex xs2>
                                            <div
                                                class="body-2 font-weight-medium mb-1"
                                            >
                                                Source:
                                            </div>
                                            <div class="body-2 mb-1">
                                                {{ transaction.source }}
                                            </div>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                        <v-flex xs3>
                                            <v-layout
                                                column
                                                align-end
                                                class="mx-0 pr-4"
                                            >
                                                <div
                                                    class="subheading mb-1"
                                                    v-bind:class="{
                                                        'text-danger':
                                                            transaction.amount <
                                                            0,
                                                    }"
                                                >
                                                    {{
                                                        transaction.amount
                                                            | currency
                                                    }}
                                                </div>
                                                <!-- <div
                                                    class="text--disabled subheading"
                                                >
                                                    {{ transaction.pmtType }}
                                                </div> -->
                                            </v-layout>
                                        </v-flex>
                                    </template>
                                    <v-card>
                                        <v-flex xs12>
                                            <v-card-text
                                                class="subheading mt-2"
                                            >
                                                <v-layout row class="px-3 py-2">
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Date:
                                                    </div>
                                                    <div>
                                                        {{
                                                            transaction.dateTime
                                                                | time
                                                        }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="px-3 py-2">
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Amount:
                                                    </div>
                                                    <div>
                                                        {{
                                                            transaction.amount
                                                                | currency
                                                        }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="px-3 py-2">
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Last Updated:
                                                    </div>
                                                    <div>
                                                        {{
                                                            transaction.lastUpdated
                                                                | time
                                                        }}
                                                    </div>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="px-3 py-2"
                                                    v-for="prop in getProperties(
                                                        transaction
                                                    )"
                                                >
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        {{ prop.name }}:
                                                    </div>
                                                    <div>
                                                        {{ prop.value }}
                                                    </div>
                                                </v-layout>
                                            </v-card-text>
                                        </v-flex>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import {
    groupBy,
    formatPhoneNumber,
    toTitleCase,
    except,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        donor: null,
        phonesNumbers: [],
        transactions: [],
        processing: false,
        loading: true,

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async created() {
        await this.load();
    },
    methods: {
        async load() {
            await this.loadDonor();
        },
        async loadDonor() {
            const donor = await this.$http.get(
                "api/donors/getDonor?personID=" + this.$route.params.id
            );

            this.donor = donor;
            this.loading = false;

            this.loadPhones();
            this.loadTransactions();
        },
        async loadPhones() {
            const phones = await this.$http.get(
                "api/donors/GetPhones?personID=" + this.$route.params.id
            );

            this.phonesNumbers = phones;
        },
        async loadTransactions() {
            const transactions = await this.$http.get(
                "api/donors/GetTransactions?personID=" + this.$route.params.id
            );

            this.transactions = transactions;
        },
        getPhoneType(phoneType) {
            switch (phoneType) {
                case "PHON":
                    return "Home Phone";
                case "CEL":
                    return "Cellphone";
                case "MCEL":
                    return "Mother Cellphone";
            }
        },
        getProperties(transaction) {
            return Object.keys(
                except(
                    transaction,
                    "dateTime",
                    "amount",
                    "lastUpdated",
                    "cCnum"
                )
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: transaction[key],
                    };
                })
                .filter((p) => p.value);
        },
        getStatusIcon(payment) {
            return "mdi-currency-usd";
        },
        getStatusIconColor(transaction) {
            return transaction.pmtType == "Pledge" ? "info" : "success";
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
.spacail-needs-link {
    color: rgb(76, 175, 80);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.expansion-panel-margin .v-expansion-panel__header {
    margin-top: 5px;
    margin-bottom: 5px;
}
</style>
